<template>
  <v-container>
    <v-tab-item class="pb-0" eager>
      <div class="display-1 font-weight-normal mb-6 text-center">Selecione as Datas que serão apagadas</div>
      <first-tab-content
        :itemsTable="itemsTableFirstTab"
        :selectedItem.sync="selectedItemFirstTab"
        :loading="loadingFirstTab"
        @stepReleased="$emit('step-observer', { step: 0, complete: $event })"
      />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <div class="display-1 font-weight-normal mb-6 text-center">Selecione as Entidades que serão apagadas</div>
      <second-tab-content
        :itemsTable="itemsTableSecondTab"
        :selectedItem.sync="selectedItemSecondTab"
        :loading="loadingSecondTab"
        @stepReleased="
          ($emit('step-observer', { step: 1, complete: $event }), $emit('step-observer', { step: 2, complete: $event }))
        "
      />
    </v-tab-item>
    <v-tab-item class="pb-0" eager>
      <div class="display-1 font-weight-normal mb-6 text-center">Verifique as informações e confirme</div>
      <third-tab-content ref="resumo" :itemsResumo="selectedItemSecondTab" />
    </v-tab-item>
  </v-container>
</template>

<script>
  import GeorreferenciadoService from '@/services/RemoverGeorreferenciadoService';
  export default {
    components: {
      FirstTabContent: () => import('@/components/removedorGeorreferenciado/tabs/FirstTabContent.vue'),
      SecondTabContent: () => import('@/components/removedorGeorreferenciado/tabs/SecondTabContent.vue'),
      ThirdTabContent: () => import('@/components/removedorGeorreferenciado/tabs/ThirdTabContent.vue')
    },

    emits: ['step-observer'],

    data() {
      return {
        loadingFirstTab: false,
        loadingSecondTab: false,
        itemsTableFirstTab: [],
        itemsTableSecondTab: [],

        selectedItemFirstTab: [],
        selectedItemSecondTab: []
      };
    },

    created() {
      this.fillFirstTab();
    },

    methods: {
      fillFirstTab() {
        this.loadingFirstTab = true;

        GeorreferenciadoService.getDatesAndRegistersImportedEntities()
          .then((response) => (this.itemsTableFirstTab = response.data.itemsTableFirstTab))
          .finally(() => (this.loadingFirstTab = false));
      },
      fillSecondTab() {
        this.loadingSecondTab = true;
        let datas = [];
        let versoes = [];

        this.selectedItemFirstTab.forEach(function (key) {
          datas.push(key.DataRegistro);
          versoes.push(key.versao);
        });

        GeorreferenciadoService.getEntitiesByDates(datas, versoes)
          .then((response) => (this.itemsTableSecondTab = response.data.data))
          .finally(() => (this.loadingSecondTab = false));
      },

      exportData() {
        let arrTabelas = [];
        let datas_versoes = [
          {
            data: this.selectedItemFirstTab[0].DataRegistro,
            versao: this.selectedItemFirstTab[0].versao
          }
        ];

        this.selectedItemSecondTab.forEach((item) => {
          arrTabelas.push(item.tabela_origem);
        });

        return {
          tabelas: JSON.stringify(arrTabelas),
          datas_registros_versoes: JSON.stringify(datas_versoes),
          numero_linhas: this.$refs.resumo.totalRegistros()
        };
      }
    },

    watch: {
      selectedItemFirstTab() {
        this.selectedItemSecondTab = [];
        this.fillSecondTab();
      }
    }
  };
</script>